const routes = [
    {
        name: 'marcaEmpresa',
        path: '/assinatura_digital/configuracoes/marca_empresa',
        component: () => import('@/domains/configuracoes/marca_empresa/views/Editar'),
    }
]

export default routes